import { css } from '@emotion/react'

const S = {
  default: css`
    overflow: hidden;
    display: none;

    &.is-open {
      display: block;
    }
  `,
}

export default S
